import { render, staticRenderFns } from "./CampagnaTabella.vue?vue&type=template&id=f4a975b6&"
import script from "./CampagnaTabella.vue?vue&type=script&lang=ts&"
export * from "./CampagnaTabella.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports